module.exports = __webpack_public_path__ + "img/icon_tel.4e9bd1b3.svg";